import { ComponentProps } from 'react';

import { Button, styled } from '@project44/manifest-ds';

const StyledButton = styled(Button, {
  color: '$palette-indigo-600',
});

type TTextButtonProps = Omit<
  ComponentProps<typeof Button>,
  'children' | 'variant'
> & {
  text: string;
};

function TextButton({ text, css, ...props }: TTextButtonProps) {
  return (
    <StyledButton
      data-testid="text-button"
      variant="tertiary"
      size="small"
      css={css}
      {...props}
    >
      {text}
    </StyledButton>
  );
}

export default TextButton;
